import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";

const NAV = [
  { href: "#como-funciona", label: "Como funciona" },
  { href: "#recursos", label: "Recursos" },
  { href: "#lojas", label: "Lojas" },
  { href: "#precos", label: "Preços" },
  { href: "#faq", label: "Dúvidas" },
] as const;

export function SiteHeader(): JSX.Element {
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[77.5rem] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <a href="#topo" aria-label="LucraLink, voltar ao topo" className="rounded-md">
          <BrandLogo />
        </a>
        <nav aria-label="Navegação principal" className="hidden items-center gap-7 lg:flex">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
              {item.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-1.5 sm:gap-2">
          <Button asChild variant="ghost" size="sm" className="text-foreground">
            <Link to="/login">Entrar</Link>
          </Button>
          <Button asChild variant="signal" size="sm" className="lp-press">
            <Link to="/cadastro">Criar conta grátis</Link>
          </Button>
        </div>
      </div>
    </header>
  );
}

export function CtaFinal(): JSX.Element {
  return (
    <section aria-labelledby="cta-heading" className="bg-signal text-signal-foreground">
      <div className="mx-auto flex max-w-[77.5rem] flex-col gap-10 px-4 py-24 sm:px-6 md:flex-row md:items-end md:justify-between lg:px-8 lg:py-32">
        <h2
          id="cta-heading"
          className="max-w-[16ch] text-[clamp(2.25rem,1.4rem+3.4vw,4.5rem)] font-bold leading-[1.02] tracking-[-0.04em] text-signal-foreground"
        >
          O próximo link que passar no seu grupo pode ser seu.
        </h2>
        <Link
          to="/cadastro"
          className="lp-press inline-flex h-14 shrink-0 items-center gap-2 self-start rounded-lg bg-signal-foreground px-7 text-base font-semibold text-signal transition-[filter] hover:brightness-150 focus-visible:outline-signal-foreground md:self-auto"
        >
          Criar conta grátis
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}

export function SiteFooter(): JSX.Element {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto grid max-w-[77.5rem] gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr] lg:px-8">
        <div>
          <BrandLogo compact />
          <p className="mt-4 max-w-[36ch] text-sm leading-relaxed text-muted-foreground">
            Automação de links de afiliado para quem divulga ofertas no Telegram e no WhatsApp.
          </p>
        </div>
        <nav aria-label="Conta" className="flex flex-col gap-3 text-sm">
          <Link to="/login" className="text-muted-foreground transition-colors hover:text-foreground">
            Entrar
          </Link>
          <Link to="/cadastro" className="text-muted-foreground transition-colors hover:text-foreground">
            Criar conta grátis
          </Link>
          <a href="#precos" className="text-muted-foreground transition-colors hover:text-foreground">
            Planos
          </a>
        </nav>
        <nav aria-label="Legal" className="flex flex-col gap-3 text-sm">
          <Link to="/termos" className="text-muted-foreground transition-colors hover:text-foreground">
            Termos de uso
          </Link>
          <Link to="/privacidade" className="text-muted-foreground transition-colors hover:text-foreground">
            Privacidade
          </Link>
          <a href="/contato/" className="text-muted-foreground transition-colors hover:text-foreground">
            Contato
          </a>
        </nav>
      </div>
      <p className="mx-auto max-w-[77.5rem] px-4 pb-10 text-xs text-muted-foreground sm:px-6 lg:px-8">
        © {new Date().getFullYear()} LucraLink
      </p>
    </footer>
  );
}
